<template>
  <div>
    <b-modal
      ref="add-by-date-modal"
      hide-footer
      title="Thêm mới cộng trừ khác hoa hồng cửa hàng theo ngày"
    >
      <v-form ref="form" lazy-validation>
        <b-row>
          <b-col cols="8">
            <b-form-group
              label="Cửa hàng:"
              label-align-md="left"
              class="required-control"
            >
              <b-row>
                <b-col cols="9">
                  <Autosuggest
                    class="border-radius-none"
                    :model="searchStore"
                    :suggestions="filteredOptions"
                    placeholder="cửa hàng"
                    :limit="200"
                    @select="onSelectedStore"
                    @change="onInputChange"
                  >
                    <template #custom="{ suggestion }">
                      <div>
                        <span>{{ suggestion.item.suggestionName }}</span>
                      </div>
                    </template>
                  </Autosuggest>
                </b-col>
                <b-col cols="3">
                  <b-button
                    class="font-weight-bolder"
                    variant="primary"
                    @click="getEmployeeInBillByDate"
                    ><i class="fas fa-search text-white fa-lg"></i
                  ></b-button>
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-form-group label-align-md="left" label="Ngày" class="col-md-6">
            <date-picker
              placeholder="Ngày"
              class="form-control form-control-sm"
              :config="dpConfigs.date"
              v-model="mainModel.date"
            ></date-picker>
          </b-form-group>
          <b-form-group
            label="Nguồn từ:"
            label-align-md="left"
            class="col-md-6"
          >
            <b-form-select
              v-model="mainModel.sourceType"
              size="sm"
              @change="assignValue"
              class="select-style"
            >
              <b-form-select-option value="1"> Khác </b-form-select-option>
              <b-form-select-option value="2"> CSKH </b-form-select-option>
              <b-form-select-option value="3"> QA </b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-row>
        <b-row>
          <b-col cols="6">
            <b-row>
              <b-col>
                <b-form-group
                  label="Loại:"
                  label-align-md="left"
                  class="required-control"
                >
                  <b-form-select
                    v-model="mainModel.operatorType"
                    size="sm"
                    class="select-style"
                  >
                    <b-form-select-option value="1">
                      Khen
                    </b-form-select-option>
                    <b-form-select-option value="2">
                      Hài lòng
                    </b-form-select-option>
                    <b-form-select-option value="3">
                      Không hài lòng
                    </b-form-select-option>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="6">
            <b-form-group
              label="Giá trị:"
              label-align-md="left"
              class="required-control"
            >
              <b-input
                type="text"
                size="sm"
                class="input-style text-right"
                v-model="mainModel.amount"
                v-mask="mask"
                @change="assignValue"
              ></b-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group
              label="Lý do:"
              label-align-md="left"
              class="required-control"
            >
              <b-form-select
                v-model="mainModel.reasonType"
                size="sm"
                class="select-style"
                :options="listReason"
                value-field="id"
                text-field="name"
              >
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label="Mô tả">
              <b-form-textarea
                v-model="mainModel.description"
                placeholder="Nhập mô tả"
                rows="3"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-form-group label="Nhân viên:" class="col-md-6 pl-0">
          <Autosuggest
            :model="searchEmployee"
            :suggestions="filteredOptionEmployee"
            placeholder="nhân viên"
            :limit="10"
            @select="onSelectedEmployee"
            @change="onInputChangeEmployee"
          >
            <template #custom="{ suggestion }">
              <div>
                <span>{{ suggestion.item.suggestionName }}</span>
              </div>
            </template>
          </Autosuggest>
        </b-form-group>
        <b-row class="mb-2">
          <b-col md="4">
            <b-button
              variant="warning"
              size="sm"
              class="mb-4"
              @click="showDeleteEmpAlert"
            >
              Xóa nhân viên
            </b-button>
          </b-col>
          <b-col md="4"> </b-col>
          <b-col md="4"> </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" md="12">
            <div>
              <b-table bordered hover :fields="fieldEmp" :items="listEmp">
                <template v-slot:head(selected)>
                  <span>
                    <b-form-checkbox
                      v-model="checkAllEmp"
                      size="lg"
                      @change="checkAllEmployee"
                    ></b-form-checkbox>
                  </span>
                </template>
                <template v-slot:cell(selected)="row">
                  <div class="d-flex justify-content-center">
                    <b-form-checkbox
                      v-model="row.item.selected"
                      @change="clickIndexEmployee"
                    ></b-form-checkbox>
                  </div>
                </template>
                <template v-slot:cell(amount)="row">
                  <b-input
                    type="text"
                    size="sm"
                    class="input-style text-right"
                    v-model="row.item.amount"
                  ></b-input>
                  <p
                    style="font-size: 11px; margin-top: 2px"
                    class="font-weight-bold"
                  >
                    ({{ formatMoney(row.item.amount) }})
                  </p>
                </template>
                <template v-slot:cell(actions)="row">
                  <v-icon
                    small
                    class="text-danger"
                    @click="showDeleteAlertEmp(row.item)"
                    v-b-tooltip
                    title="Xóa"
                    >mdi-delete</v-icon
                  >
                </template>
              </b-table>
            </div>
          </b-col>
          <b-col cols="6" md="4"></b-col>
        </b-row>
        <b-button
          style="fontweight: 600; width: 70px"
          variant="primary"
          size="sm"
          @click="onSubmit()"
          >Lưu</b-button
        >
        <b-button
          style="margin-left: 10px; font-weight: 600; width: 70px"
          variant="secondary"
          size="sm"
          @click="hideModal()"
          >Hủy</b-button
        >
      </v-form>
    </b-modal>
  </div>
</template>
<script>
// Import datePicker component
import datePicker from 'vue-bootstrap-datetimepicker';
// Import date picker css
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import jQuery from 'jquery';
// Using font-awesome 5 icons
import '@fortawesome/fontawesome-free/css/fontawesome.css';
import '@fortawesome/fontawesome-free/css/regular.css';
import '@fortawesome/fontawesome-free/css/solid.css';
import moment from 'moment';
jQuery.extend(true, jQuery.fn.datetimepicker.defaults, {
  icons: {
    time: 'far fa-clock',
    date: 'far fa-calendar',
    up: 'fas fa-arrow-up',
    down: 'fas fa-arrow-down',
    previous: 'fas fa-chevron-left',
    next: 'fas fa-chevron-right',
    today: 'fas fa-calendar-check',
    clear: 'far fa-trash-alt',
    close: 'far fa-times-circle',
  },
});
import ApiService from '@/core/services/api.service';
import {
  makeToastFaile,
  currencyMask,
  unMaskPrice,
  xoa_dau,
  formatPrice,
} from '@/utils/common';
import Swal from 'sweetalert2';
import _ from 'lodash';
import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue';
import { REWARD_DETAIL_REASON } from '@/utils/constants';

export default {
  props: [],
  data() {
    return {
      dpConfigs: {
        date: {
          format: 'DD/MM/YYYY',
          useCurrent: false,
          showClear: true,
          showClose: true,
          minDate: false,
          maxDate: false,
          locale: 'vi',
          sideBySide: true,
        },
      },
      mainModel: {
        billNumber: '',
        billStoreId: null,
        billStoreName: '',
        billCreatedAt: '',
        date: moment().format('DD/MM/YYYY'),
        operatorType: 1,
        amountType: 1,
        sourceType: 1,
        amount: 0,
        description: '',
        reasonType: null,
      },
      listEmp: [],
      fieldEmp: [
        {
          key: 'selected',
          label: '',
          thStyle: { textAlign: 'center', width: '5%' },
        },
        {
          key: 'code',
          label: 'MSNV',
          thStyle: { width: '20%' },
        },
        {
          key: 'fullName',
          label: 'Tên nhân viên',
          thStyle: { width: '40%' },
        },
        {
          key: 'amount',
          label: 'Giá trị',
          tdClass: 'text-right',
          thStyle: { width: '30%' },
        },
        {
          key: 'actions',
          label: '',
        },
      ],
      selected: [],
      checkAllEmp: false,
      mask: currencyMask,
      filteredOptions: [],
      options: [
        {
          data: [],
        },
      ],
      searchStore: '',
      filteredOptionEmployee: [],
      optionEmployee: [
        {
          data: [],
        },
      ],
      searchEmployee: '',
      listReason: REWARD_DETAIL_REASON,
    };
  },
  methods: {
    showModal: function () {
      this.fetchStoreByUser();
      this.fetchEmployee();
      this.listEmp = [];
      this.mainModel = {
        billNumber: '',
        billStoreId: null,
        date: moment().format('DD/MM/YYYY'),
        operatorType: 1,
        amountType: 1,
        sourceType: 1,
        amount: 0,
        description: '',
        reasonType: null,
      };
      this.searchStore = '';
      this.$refs['add-by-date-modal'].show();
    },
    hideModal: function () {
      this.$refs['add-by-date-modal'].hide();
    },
    getEmployeeInBillByDate() {
      const date = this.mainModel.date
        ? moment(this.mainModel.date, 'DD/MM/YYYY').format('yyyy-MM-DD')
        : null;
      if (!date) {
        return makeToastFaile('Vui lòng nhập ngày!');
      }
      if (!this.searchStore.trim()) {
        this.mainModel.billStoreId = null;
      }
      if (!this.mainModel.billStoreId) {
        return makeToastFaile('Vui lòng chọn cửa hàng!');
      }
      const params = {
        storeId: this.mainModel.billStoreId,
        date: date,
      };
      ApiService.query(`bills/bill-employees/by-date`, { params }).then(
        (response) => {
          if (response.data.status === 0) {
            return makeToastFaile('Tải thông tin hóa đơn thất bại!');
          }
          const dataRes = response.data.data;
          this.listEmp = dataRes.employees.map((emp) => {
            return {
              ...emp,
              selected: false,
              amount: 0,
            };
          });
        },
      );
    },
    checkAllEmployee() {
      this.listEmp.forEach((element) => {
        element.selected = this.checkAllEmp;
      });
    },
    clickIndexEmployee() {
      if (this.checkAllEmp == true) {
        this.checkAllEmp = false;
      } else {
        var count = 0;
        this.listEmp.forEach((element) => {
          if (element.selected == true) {
            count += 1;
            if (count == this.listEmp.length) {
              this.checkAllEmp = true;
            }
          }
        });
      }
    },
    showDeleteEmpAlert: function () {
      const idSelected = this.listEmp
        .filter((emp) => emp.selected)
        .map((x) => x.id);

      if (!idSelected || !idSelected.length) {
        this.makeToastFaile('Vui lòng chọn nhân viên cần xóa!');
        return;
      }

      Swal.fire({
        title: 'Xóa danh sách nhân viên đã chọn!',
        text: 'Bạn có chắc muốn xóa các nhân viên đã chọn này khỏi cộng trừ theo cửa hàng không ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'rgb(221, 51, 51)',
        cancelButtonColor: '#E5EAEE',
        confirmButtonText: 'Xóa',
        cancelButtonText: '<span style="color:#464E5F">Hủy</span>',
        reverseButtons: true,
        showClass: {
          popup: 'animate__animated animate__fadeInDown',
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp',
        },
        position: 'top',
      }).then((result) => {
        if (result.value) {
          this.deletedEmployee(idSelected);
        }
      });
    },
    deletedEmployee(empIds) {
      this.listEmp = _.remove(this.listEmp, function (emp) {
        return !empIds.includes(emp.id);
      });
    },
    onSubmit() {
      this.listDetailByEmp = [];
      const date = this.mainModel.date
        ? moment(this.mainModel.date, 'DD/MM/YYYY').valueOf()
        : null;
      const amount = this.mainModel.amount
        ? unMaskPrice(this.mainModel.amount)
        : 0;
      if (amount <= 0) {
        makeToastFaile('Vui lòng nhập giá trị phát sinh hoa hồng!');
        return;
      }
      this.listEmp.forEach((emp) => {
        const amountValue = emp.amount ? unMaskPrice(emp.amount) : 0;
        const item = {
          date: date,
          employeeId: emp.id,
          employeeName: emp.fullName,
          operatorType: this.mainModel.operatorType === '3' ? 2 : 1,
          amountType: this.mainModel.amountType,
          amount: amountValue,
          description: this.mainModel.description,
          storeId: this.mainModel.billStoreId,
          sourceType: this.mainModel.sourceType,
          reasonType: this.mainModel.reasonType,
        };
        this.listDetailByEmp.push(item);
      });
      const payload = {
        listDetail: this.listDetailByEmp,
      };
      this.$emit('onSubmit', payload);
    },
    showDeleteAlertEmp: function (item) {
      Swal.fire({
        title: 'Xóa nhân viên!',
        text: 'Bạn có chắc muốn xóa nhân viên này không ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'rgb(221, 51, 51)',
        cancelButtonColor: '#E5EAEE',
        confirmButtonText: 'Xóa',
        cancelButtonText: '<span style="color:#464E5F">Hủy</span>',
        reverseButtons: true,
        showClass: {
          popup: 'animate__animated animate__fadeInDown',
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp',
        },
        position: 'top',
      }).then((result) => {
        if (result.dismiss != 'cancel') {
          this.listEmp = _.reject(this.listEmp, (x) => {
            return x.id == item.id;
          });
        }
      });
    },
    assignValue() {
      let amount = this.mainModel.amount
        ? unMaskPrice(this.mainModel.amount)
        : 0;
      if (this.mainModel.sourceType === '3') {
        amount = amount / this.listEmp.length;
      }
      this.listEmp = this.listEmp.map((emp) => {
        return {
          ...emp,
          amount: this.roundMoney(amount),
        };
      });
    },
    roundMoney(value) {
      const tmpValue = Math.round(value / 100);
      return tmpValue * 100;
    },
    onSelectedStore(option) {
      this.searchStore = option.item.name;
      this.mainModel.billStoreId = option.item.id;
    },
    onInputChange(text) {
      this.searchStore = text;
      const filteredData = this.options[0].data
        .filter((item) => {
          return (
            item.name.toLowerCase().indexOf(text.toLowerCase()) > -1 ||
            item.shortName.toLowerCase().indexOf(text.toLowerCase()) > -1
          );
        })
        .slice(0, 10);
      this.filteredOptions = [...filteredData];
    },
    fetchStoreByUser() {
      ApiService.get(`stores/get-by-user`).then(({ data }) => {
        if (data.status === 1) {
          const stores = data.data.stores;
          if (stores.length === 1) {
            this.mainModel.billStoreId = stores[0].id;
            this.searchStore = stores[0].name;
          } else {
            this.options[0].data = stores.map((element) => {
              return {
                id: element.id,
                name: element.name,
                shortName: element.shortName,
                suggestionName: element.shortName + ' ( ' + element.name + ')',
              };
            });
            this.filteredOptions = [...this.options[0].data];
          }
        }
      });
    },
    fetchEmployee: async function () {
      this.optionEmployee[0].data = [];
      ApiService.get('/employees/get-list-filter').then((response) => {
        const employees = response.data.data;
        this.optionEmployee[0].data = employees.map((element) => {
          let suggestionName = element.name;
          if (element.code) {
            suggestionName += ' ( ' + element.code + ')';
          }
          return {
            id: element.id,
            name: element.name,
            code: element.code,
            suggestionName: suggestionName,
            nameNoneSign: xoa_dau(element.name),
          };
        });
        this.filteredOptionEmployee = [...this.optionEmployee[0].data];
      });
    },
    onSelectedEmployee(option) {
      const empDetail = {
        id: option.item.id,
        code: option.item.code,
        fullName: option.item.name,
        selected: false,
        amount: 0,
      };
      this.listEmp.push(empDetail);
      this.searchEmployee = '';
    },
    onInputChangeEmployee(text) {
      if (!text) {
        text = '';
      }
      this.searchEmployee = text;

      /* Full control over filtering. Maybe fetch from API?! Up to you!!! */
      const filteredData = this.optionEmployee[0].data
        .filter((item) => {
          return (
            item.nameNoneSign.toLowerCase().indexOf(text.toLowerCase()) > -1 ||
            item.name.toLowerCase().indexOf(text.toLowerCase()) > -1 ||
            item.code.toLowerCase().indexOf(text.toLowerCase()) > -1
          );
        })
        .slice(0, this.limit);

      this.filteredOptionEmployee = [...filteredData];
    },
    formatMoney(value) {
      return formatPrice(value);
    },
  },
  components: {
    datePicker,
    Autosuggest,
  },
};
</script>

<style>
.center-label label {
  margin-bottom: 0px;
}
</style>
